<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.handout.title"></sc-dictionary-label>
    </h2>



    <div class="top-info">
      {{handout.name}} {{handout.firstname}} {{handout.company}}
    </div>

    <div class="dialog-content" [formGroup]="formGroup">

      <sc-flex vertical stretchContent class="no-field-space">
        <ng-container *ngFor="let se of handout.supplementaryEquipments">
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex [formGroupName]="se.key">
            <div class="checkbox-label">
              <mat-checkbox formControlName="selected">
                <sc-dictionary-label dictionaryKey="se.dictionaryKey"></sc-dictionary-label>
              </mat-checkbox>
            </div>
            <ng-container *ngIf="se.availableIdentifiers?.length > 0">
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field class="checkbox-value" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-common.entity.equipment.identifier"></sc-dictionary-label>
                </mat-label>
                <mat-select name="identity" formControlName="identifier" [disabled]="!se.selected || isFormReadonly()" required="true">
                  <mat-option *ngFor="let identity of se.availableIdentifiers" [value]="identity">{{identity}}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <sc-content-spacer *ngIf="isStringParameter(se)"></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isStringParameter(se)" formControlName="parameter1Value" appearance="fill">
              <mat-label>
                <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
              </mat-label>
              <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}" required
                [disabled]="!se.selected || isFormReadonly()" [readonly]="isFormReadonly()">
            </mat-form-field>
            <sc-content-spacer *ngIf="isNumberParameter(se)"></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isNumberParameter(se)" formControlName="parameter1Value" appearance="fill">
              <mat-label>
                <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
              </mat-label>
              <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                required [disabled]="!se.selected || isFormReadonly()" [readonly]="isFormReadonly()" >
            </mat-form-field>
          </sc-flex>
        </ng-container>
      </sc-flex>
    </div>


    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()"></sc-save-button>
    </sc-actionbar>
  </div>
</div>
